import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {WritableDraft} from "immer/dist/internal";
import {RootState} from "../../app/store";
import {SliceStatus} from "../BaseState";
import {PaginationState} from "./PaginationState";

const initialState: PaginationState = {
  page: 1,
  limit: 20,
  pendings: [],
  status: SliceStatus.idle,
  error: null
};

export const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPage: (draft: WritableDraft<PaginationState>, action: PayloadAction<number>) => {
      draft.page = action.payload;
    },
    setLimit: (draft: WritableDraft<PaginationState>, action: PayloadAction<number>) => {
      draft.limit = action.payload;
    }
  }
});

export const {setPage, setLimit} = paginationSlice.actions;
export const paginationState = (state: RootState): PaginationState => state.pagination;
export default paginationSlice.reducer;
